<template id="Trend">
  <section>
    <div class="trend" trigger="hover">
      <!--  本週熱門主題 Begin  -->
      <div class="title">
        本週熱門主題
        <div class= "categoryFilterDiv">
          <el-button type="text" :class="categoryFilterBtnStyle" @click="categoryFilterClick()">
             {{ categoryFilterLabel }}
             <i class="el-icon-circle-check el-icon--right"></i>
          </el-button>
          <el-card class="categoryFilterCard" id="categoryFilterElement" style="display:none">
            <div slot="header" >
              <el-button class="applyBtn" @click="categoryFilterApply()">套用</el-button>
              <el-button class="cancelBtn" @click="categoryFilterCancel()">取消</el-button>
              <el-button type="text" @click="categoryFilterDefault()">恢復預設值</el-button>
            </div>
            <div>
              <el-checkbox-group v-model="categoryFilterList">
                <div v-for="categoryGroup in categoryGroupList" :key="categoryGroup.id"
                 class="category-filter-group">
                  <div class="category-filter-group-title">
                    {{ categoryGroup.name }}
                  </div>
                  <div v-for="category in categoryGroup.category"	:key="category.id">
                    <el-checkbox  :label="category.id" >
                      {{ category.title }}
                    </el-checkbox>
                  </div>
                </div>
              </el-checkbox-group>
            </div>
          </el-card>
        </div>
      </div>
      <div v-loading="weekListLoading" class="swiperContainer">
        <el-button v-show="preWeekBtnVisible" class="swiperbtn preBtn el-icon-arrow-left" @click="prev('week')"></el-button>
        <swiper ref="weekSwiper" class="swiper swiperStyle swiper-no-swiping" :options="swiperOption" :auto-update="false">
          <swiper-slide v-for="obj in weekResources" :key="obj.id" class="swiperSlide">
            <div class="swiperDiv" @click="clickSwiper(obj.id)">
              <div class="resouceTitle">{{ obj.title }}</div>
                {{ obj.authorName }} <span v-if="obj.authorName && obj.authorName != '' ">,</span> {{ obj.authorDep }} <br/>
                <StarRating 
									:rating="obj.ratingAverage"
                  :show-rating="false"
									:max-rating="5"
                  :increment="0.1"
									:star-size="14"
									:read-only="true" 
                  style="float:left" >
								</StarRating>&nbsp;
                {{ obj.ratingAverage }}  ({{ obj.ratingCount }}) <br/>
                {{ formatTime(obj.mtime) }}更新 ‧ {{ obj.viewCount }}次觀看 <br/>
              <div class="resouceCategory">{{ obj.category }}</div>
              <div class="resouceCompulsory" v-if="obj.course_type === 1">必修</div>
              <div class="resouceElective" v-if="obj.course_type === 0">選修</div>
            </div>        
          </swiper-slide>
        </swiper>
        <el-button v-show="nextWeekBtnVisible" class="swiperbtn nextBtn el-icon-arrow-right" @click="next('week')"></el-button>
        <div v-if="weekNoData" class= "noDataDiv">
          抱歉，您選取的類別中找不到主題
          <div class= "noDataSubDiv">
            請嘗試選取更多類別
          </div>
        </div>
      </div>
     
      <!--  本週熱門主題 End  -->

      <!--  歷史熱門主題 Begin  -->
      <div class="title">
        歷史熱門主題
      </div>
      <div v-loading="settingListLoading" class="swiperContainer">
        <el-button v-show="preSettingBtnVisible" class="swiperbtn preBtn el-icon-arrow-left" @click="prev('setting')"></el-button>
        <swiper ref="settingSwiper" class="swiper swiperStyle swiper-no-swiping" :options="swiperOption" :auto-update="false">
          <swiper-slide v-for="obj in settingResources" :key="obj.id" class="swiperSlide">
            <div class="swiperDiv" @click="clickSwiper(obj.id)">
              <div class="resouceTitle">{{ obj.title }}</div>
                {{ obj.authorName }} <span v-if="obj.authorName && obj.authorName != '' ">,</span> {{ obj.authorDep }} <br/>
                <StarRating 
									:rating="obj.ratingAverage"
                  :show-rating="false"
									:max-rating="5"
                  :increment="0.1"
									:star-size="14"
									:read-only="true" 
                  style="float:left" >
								</StarRating>&nbsp;
                {{ obj.ratingAverage }}  ({{ obj.ratingCount }}) <br/>
                {{ formatTime(obj.mtime) }}更新 ‧ {{ obj.viewCount }}次觀看 <br/>
              <div class="resouceCategory">{{ obj.category }}</div>
              <div class="resouceCompulsory" v-if="obj.course_type === 1">必修</div>
              <div class="resouceElective" v-if="obj.course_type === 0">選修</div>
            </div>        
          </swiper-slide>
        </swiper>
        <el-button v-show="nextSettingBtnVisible" class="swiperbtn nextBtn el-icon-arrow-right" @click="next('setting')"></el-button>
        <div v-if="settingNoData" class= "noDataDiv">
          抱歉，您選取的類別中找不到主題
          <div class= "noDataSubDiv">
            請嘗試選取更多類別
          </div>
        </div>
      </div>
      <!--  歷史熱門主題 End  -->

      <!--  累積最熱門主題 Begin  -->
      <div class="title">
        累積最熱門主題
      </div>
      <div v-loading="allListLoading" class="swiperContainer">
        <el-button v-show="preAllBtnVisible" class="swiperbtn preBtn el-icon-arrow-left" @click="prev('all')"></el-button>
        <swiper ref="allSwiper" class="swiper swiperStyle  swiper-no-swiping" :options="swiperOption" :auto-update="false">
          <swiper-slide v-for="obj in allResources" :key="obj.id" class="swiperSlide">
            <div class="swiperDiv" @click="clickSwiper(obj.id)">
              <div class="resouceTitle">{{ obj.title }}</div>
                {{ obj.authorName }} <span v-if="obj.authorName && obj.authorName != '' ">,</span> {{ obj.authorDep }} <br/>
                <StarRating 
									:rating="obj.ratingAverage"
                  :show-rating="false"
									:max-rating="5"
                  :increment="0.1"
									:star-size="14"
									:read-only="true" 
                  style="float:left" >
								</StarRating>&nbsp;
                {{ obj.ratingAverage }}  ({{ obj.ratingCount }}) <br/>
                {{ formatTime(obj.mtime) }}更新 ‧ {{ obj.viewCount }}次觀看 <br/>
              <div class="resouceCategory">{{ obj.category }}</div>
              <div class="resouceCompulsory" v-if="obj.course_type === 1">必修</div>
              <div class="resouceElective" v-if="obj.course_type === 0">選修</div>
            </div>        
          </swiper-slide>
        </swiper>
        <el-button v-show="nextAllBtnVisible" class="swiperbtn nextBtn el-icon-arrow-right" @click="next('all')"></el-button>
        <div v-if="allNoData" class= "noDataDiv">
          抱歉，您選取的類別中找不到主題
          <div class= "noDataSubDiv">
            請嘗試選取更多類別
          </div>
        </div>
      </div>
      <!--  累積最熱門主題 End  -->

      <!--  熱門作者 Begin  -->
      <div class="title">
        熱門作者
      </div>
      <div v-loading="authorsLoading" class="authorContainer">
        <el-button v-show="preAuthorsBtnVisible" class="swiperbtn preBtn el-icon-arrow-left" @click="prev('author')"></el-button>
        <swiper ref="authorSwiper" class="swiper swiperStyle swiper-no-swiping" :options="swiperOptionAuthor" :auto-update="false">
          <swiper-slide v-for="obj in allAuthors" :key="obj.name" class="swiperSlide">
            <div class="swiperDiv" @click="clickAuthor(obj.name, obj.user.displayname)">
              {{ obj.user.displayname }} 
              <div class="swiperDepDiv"> 
                {{ obj.actual_dep ? obj.actual_dep.name: obj.dep.title }} 
              </div>
            </div>        
          </swiper-slide>
        </swiper>
        <el-button v-show="nextAuthorsBtnVisible" class="swiperbtn nextBtn el-icon-arrow-right" @click="next('author')"></el-button>
        <div v-if="authorsNoData" class= "noDataDiv">
          抱歉，您選取的類別中找不到作者
          <div class= "noDataSubDiv">
            請嘗試選取更多類別
          </div>
        </div>
      </div>
      <!--  熱門作者 End  -->
      <br/><br/>
      <div>
        <hint
          v-show="hint.display && this.$store.state.hintStatus.setting"
          :message="hint.message"
          @close="closeHint"
        ></hint>
      </div>
    </div>
  </section>
</template>
<script>
import API from "../../api/api";
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
export default {
    name: "Profile",
    components: {
        Swiper,
        SwiperSlide,
    },
    props: {
      categoryGroupList: {
        type: Array
      },
    },
    data() {
      return {
        categoryFilterChk: false,
        categoryFilterLabel: "全部類別",
        categoryFilterList: [],
        categoryFilterListTmp: [],
        weekNoData: false,
        settingNoData: false,
        allNoData: false,
        authorsNoData: false,
        weekListLoading: true,
        settingListLoading: true,
        allListLoading: true,
        authorsLoading: true,
        preWeekBtnVisible: false,
        nextWeekBtnVisible: false,
        preSettingBtnVisible: false,
        nextSettingBtnVisible: false,
        preAllBtnVisible: false,
        nextAllBtnVisible: false,
        preAuthorsBtnVisible: false,
        nextAuthorsBtnVisible: false,
        weekResources: [],
        settingResources: [],
        allResources: [],
        allAuthors: [],
        swiperUpdateDelay:100,
        swiperOption: {
            slidesPerView: 5,
            spaceBetween: 10,
            slidesPerGroup: 5,
            loopFillGroupWithBlank: true,
        },
        swiperOptionAuthor: {
            slidesPerView: 6,
            slidesPerColumn: 2,
            spaceBetween: 10,
            slidesPerColumnFill:'row',
            slidesPerGroup: 6,
            loopFillGroupWithBlank: true,
        },
        hint: {
            message: "",
            display: false,
        },
      };
    },
    computed: {
        categoryFilterBtnStyle() {
          if (this.categoryFilterChk) {
            return "categoryFilterBtnChk"
          }
          return "categoryFilterBtn"
        },
        weekSwiper() {
          if (this.$refs.weekSwiper) {
            return this.$refs.weekSwiper.$swiper
          }
          return null;
        },
        settingSwiper() {
          if (this.$refs.settingSwiper) {
            return this.$refs.settingSwiper.$swiper
          }
          return null;
        },
        allSwiper() {
          if (this.$refs.allSwiper) {
            return this.$refs.allSwiper.$swiper
          }
          return null;
        },
        authorSwiper() {
          if (this.$refs.authorSwiper) {
            return this.$refs.authorSwiper.$swiper
          }
          return null;
        }
    },
  created() {
    this.initial();
  },
  methods: {
    initial: function () {
      this.$store.state.nowStatus = 12;
      this.categoryFilterList = this.$store.state.checkedCategoryListForTrend;
      this.setupCategoryFilterUI();
      this.reloadData();
    },
    reloadData() {
      this.weekResources.splice(0);
      this.settingResources.splice(0);
      this.allResources.splice(0);
      this.allAuthors.splice(0);
      this.weekNoData = false;
      this.settingNoData = false;
      this.allNoData = false;
      this.authorsNoData = false;
      this.weekListLoading = true;
      this.settingListLoading = true;
      this.allListLoading = true;
      this.authorsLoading = true;
      this.preWeekBtnVisible = false;
      this.nextWeekBtnVisible = false;
      this.preSettingBtnVisible = false;
      this.nextSettingBtnVisible = false;
      this.preAllBtnVisible = false;
      this.nextAllBtnVisible = false;
      this.preAuthorsBtnVisible = false;
      this.nextAuthorsBtnVisible = false;
      this.getResources();
      this.getAuthors();
    },
    async getResources() {
      let now = new Date();
      let weekStartTime = new Date();
      weekStartTime.setDate(now.getDate() - 7);

      //取得本週熱門主題
      API.getPopular(this.categoryFilterList, weekStartTime.getTime(), now.getTime(), "week").then((result) => {
        if (!result) {
          this.showHint("取得本週熱門主題錯誤!");
        } else {
          if (result.length > 0) {
            for (let i = 0; i < result.length; i++) {
              this.weekResources.push(this.formatResourceObj(result[i]));
            }
            if (result.length > this.swiperOption.slidesPerView) {
              this.nextWeekBtnVisible = true;
            }
          } else {
            this.weekNoData = true;
          }
        }
        this.weekListLoading = false;
        setTimeout(() => {
          if (this.weekSwiper) {
            this.weekSwiper.slideTo(1);
            this.weekSwiper.update();
          }
        }, this.swiperUpdateDelay)
      });

      //取得歷史熱門主題
      API.getPopular(this.categoryFilterList, null, null, "history").then((result) => {
        if (!result) {
          this.showHint("取得歷史熱門主題錯誤!");
        } else {
          if (result.length > 0) {
            for (let i = 0; i < result.length; i++) {
              this.settingResources.push(this.formatResourceObj(result[i]));
            }
            if (result.length > this.swiperOption.slidesPerView) {
              this.nextSettingBtnVisible = true;
            }
          } else {
            this.settingNoData = true;
          }
        }
        this.settingListLoading = false;
        setTimeout(() => {
          if (this.settingSwiper) {
            this.settingSwiper.slideTo(1);
            this.settingSwiper.update();
          }
        }, this.swiperUpdateDelay)
      });

      //取得累積最熱門主題
      API.getPopular(this.categoryFilterList, 0, now.getTime(), "acc").then((result) => {
        if (!result) {
          this.showHint("取得累積最熱門主題錯誤!");
        } else {
          if (result.length > 0) {
            for (let i = 0; i < result.length; i++) {
              this.allResources.push(this.formatResourceObj(result[i]));
            }
            if (result.length > this.swiperOption.slidesPerView) {
              this.nextAllBtnVisible = true;
            }
          } else {
            this.allNoData = true;
          }
        }
        this.allListLoading = false;
        setTimeout(() => {
          if (this.allSwiper) {
            this.allSwiper.slideTo(1);
            this.allSwiper.update();
          }
        }, this.swiperUpdateDelay)
      });
    },
    formatResourceObj(raw) {
       let resourceObj = {};
        resourceObj.id = raw.id;
        resourceObj.title = raw.title;
        resourceObj.authorName = raw.author.displayname;
        resourceObj.authorDep = raw.actual_dep ? raw.actual_dep.name: raw.dep.title;
        resourceObj.ratingAverage = raw.rating.average;
        resourceObj.ratingCount = raw.rating.count;
        resourceObj.viewCount = raw.count;
        resourceObj.mtime = raw.mtime;
        resourceObj.category = raw.category.title;
        resourceObj.course_type = raw.course_type;
        return resourceObj;
    },
    async getAuthors() {
      let now = new Date();
      API.getPopularAuthors(this.categoryFilterList, 0, now.getTime()).then((result) => {
        if (!result) {
          this.showHint("取得熱門作者錯誤!");
        } else {
          if (result.length > 0) {
            this.allAuthors = result;
            if (result.length > 
              this.swiperOptionAuthor.slidesPerView * this.swiperOptionAuthor.slidesPerColumn) {
              this.nextAuthorsBtnVisible = true;
            }
          } else {
            this.authorsNoData = true;
          }
        }
        this.authorsLoading = false;
        setTimeout(() => {
          if (this.authorSwiper) {
            this.authorSwiper.slideTo(1);
            this.authorSwiper.update();
          }
        }, this.swiperUpdateDelay)
      });
    },
    setupCategoryFilterUI() {
      if (this.categoryFilterList.length > 0) {
        this.categoryFilterChk = true;
        this.categoryFilterLabel = "已選取" + this.categoryFilterList.length + "個類別";
      } else {
        this.categoryFilterChk = false;
        this.categoryFilterLabel = "全部類別";
      }
    },
    categoryFilterClick() {
      document.getElementById("categoryFilterElement").style.display = "block";
      this.categoryFilterListTmp = this.categoryFilterList;
    },
    categoryFilterApply() {
      this.$store.state.checkedCategoryListForTrend = this.categoryFilterList;
      this.setupCategoryFilterUI();
      document.getElementById("categoryFilterElement").style.display="none";
      this.reloadData();
    },
    categoryFilterCancel() {
      this.categoryFilterList = this.categoryFilterListTmp;
      this.setupCategoryFilterUI();
      document.getElementById("categoryFilterElement").style.display="none";
    },
    categoryFilterDefault() {
      this.categoryFilterList = [];
      this.$store.state.checkedCategoryListForTrend = [];
      this.setupCategoryFilterUI();
      document.getElementById("categoryFilterElement").style.display="none";
      this.reloadData();
    },
    prev(type) {
      let swiper = this.getSwiper(type);
      if (swiper) {
        swiper.slidePrev();
        this.updateBtnStatus(type, swiper.isBeginning, swiper.isEnd);
      }
    },
    next(type) {
      let swiper = this.getSwiper(type);
      if (swiper) {
        swiper.slideNext();
        this.updateBtnStatus(type, swiper.isBeginning, swiper.isEnd);
      }
    },
    getSwiper(type) {
      let swiper
      if (type === 'week') {
        swiper = this.weekSwiper;
      } else if (type === 'setting') {
        swiper = this.settingSwiper;
      } else if (type === 'all') {
        swiper = this.allSwiper;
      } else if (type === 'author') {
        swiper = this.authorSwiper;
      }
      return swiper;
    },
    updateBtnStatus(type, isBeginning, isEnd) {
      if (type === 'week') {
        this.preWeekBtnVisible = !isBeginning;
        this.nextWeekBtnVisible = !isEnd;
      } else if (type === 'setting') {
        this.preSettingBtnVisible = !isBeginning;
        this.nextSettingBtnVisible = !isEnd;
      } else if (type === 'all') {
        this.preAllBtnVisible = !isBeginning;
        this.nextAllBtnVisible = !isEnd;
      } else if (type === 'author') {
        this.preAuthorsBtnVisible = !isBeginning;
        this.nextAuthorsBtnVisible = !isEnd;
      }
    },
    clickSwiper(id) {
      this.$store.state.barBreadcrumbs = [];
      this.$router.push({ path: '/info/' +  id});
    },
    clickAuthor(name, displayName) {
      this.$emit('setAuthorList', name, displayName);
    },
    formatTime(time) {
      if(time === null || time === 0 || time === undefined) {
					return '-';
				}

				let date = new Date(time);
				let year = date.getFullYear();
				let month = date.getMonth() + 1;
				let day = date.getDate();

        return year + '/' + month + '/' + day;
    },
    /**
     * closeHint close hint 視窗
     * @return none
     */
    closeHint: function () {
      this.hint.display = false;
      this.$store.state.hintStatus.setting = false;
      clearTimeout(this.timer);
    },
    /**
     * showHint
     * @param  {string} message - message
     * @return none
     */
    showHint: function (message) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.hint.display = true;
      this.hint.message = message;
      this.$store.state.showHint = true;
      this.$store.state.hintStatus.setting = true;
      this.timer = setTimeout(() => {
        if (this.$store.state.showHint) {
          this.$store.state.showHint = false;
          this.$store.state.hintStatus.info = false;
        }
      }, this.$store.state.fadeOutTime);
    },
  },
};
</script>
<style lang="scss" scoped>
.trend {
  font-family: "PingFang TC";
  letter-spacing: 0;
  line-height: 24px;

  .title {
    margin-top: 40px;
    margin-left: 30px;
    color: #3C3B38;
    font-size: 24px;
    font-weight: 500;

    .categoryFilterDiv {
      float:right;
      margin-right:30px;

      .categoryFilterBtn {
        font-size: 18px;
        color: #8A959E;
      }
      
      .categoryFilterBtnChk {
        font-size: 18px;
        color: #2E90F4;
      }
      
      .categoryFilterCard {
        position: absolute;
        max-width: 45%;
        height: auto;
        top: 70px;
        right: 50px;
        z-index: 3;
        pointer-events: auto;

        .applyBtn {
          color: #FFFFFF;
          background-color: #2E90F4;
        }

        .cancelBtn {
          color:  #2E90F4;
          border-color:  #2E90F4;
        }

        .category-filter-group {
          display: inline-block;
          vertical-align: top;
          margin-bottom: 20px;
          width: 140px;
          line-height: 26px;
          font-weight: 350;

          .category-filter-group-title {
            color: #222222;
            font-size: 16px;
            font-weight: 500;
          }
        }
      }
    }
  }

  .swiperContainer {
    height: 218px;
    width: auto;
    margin: 20px 24px 20px 24px;
    font-size: 14px;

    .swiperbtn {
      border-radius: 50%;
      border: none;
      box-shadow: -2px 2px 5px lightgray;
      cursor: pointer;
      position: relative;
      z-index: 2;
      width: 48px;
      height: 48px;
    }
    .preBtn {
      top: 85px;
      float: left;   
      margin-left: -48px;
      left: 24px;
    }
    .nextBtn {
      bottom: 133px;
      float: right;
      margin-right: -48px;
      right: 24px;
    }

    .swiperStyle {
      height: auto;
      width: auto;

      .swiperSlide {
        border-radius: 8px;
        background-color: #FFFFFF;
        cursor: pointer;

        .swiperDiv {
          height: 190px;
          padding: 14px;
          color: #515151;

          .resouceTitle {
            font-weight: 600;
            font-size: 15px;
            color: #222222;
          }

          .resouceCategory {
            display: inline-block;
            border-radius: 2px;
            background-color: #E9E9E9;
            padding: 0px 8px 0px 8px;
            margin-top: 5px;
          }

          .resouceCompulsory {
            display: inline-block;
            border-radius: 2px;
            color: #593C00;
            background-color: #FFE799;
            padding: 0px 8px 0px 8px;
            margin-top: 5px;
          }

          .resouceElective {
            display: inline-block;
            border-radius: 2px;
            color: #035C81;
            background-color: #ADEBFB;
            padding: 0px 8px 0px 8px;
            margin-top: 5px;
          }
        }
      }

      .swiperSlide:hover {
        background: #F0F7FF;
      }
    }

    .noDataDiv {
      background-color: #FFFFFF;;
      height: 218px;
      padding-top:70px;
      text-align: center;
      font-size: 20px;
      font-weight: 500;

      .noDataSubDiv {
        padding-top:10px;
        font-size: 16px;
        font-weight: 400;
        color: #515151;
      }
    }
  }

  .authorContainer {
    height: 156px; 
    width: auto;
    margin: 20px 24px 20px 24px;

    .swiperbtn {
      border-radius: 50%;
      border: none;
      box-shadow: -2px 2px 5px lightgray;
      cursor: pointer;
      position: relative;
      z-index: 2;
      width: 48px;
      height: 48px;
    }
    .preBtn {
      top: 54px;
      float: left;   
      margin-left: -48px;
      left: 24px;
    }
    .nextBtn {
      bottom: 102px;
      float: right;
      margin-right: -48px;
      right: 24px;
    }

    .swiperStyle {
      height: auto;
      width: auto;

      .swiperSlide {

        .swiperDiv {
          box-sizing: border-box;
          background-color: #FFFFFF;
          border: 1px solid #DCDACC;
          border-radius: 3px;
          cursor: pointer;
          width: auto;
          height: 73px;
          padding-top: 14px;
          text-align: center;
          color: #2E90F4;
          font-size: 16px;
          font-weight: 600;

          .swiperDepDiv {
            color: #8A959E;
            font-size: 12px;
            font-weight: 400;
            padding-top: 0px;
          }
        }

        .swiperDiv:hover {
          background: #F0F7FF;
          border: 1px solid #2E90F4;
        }
      }
    }

    .noDataDiv {
      background-color: #FFFFFF;;
      height: 156px;
      padding-top:50px;
      text-align: center;
      font-size: 20px;
      font-weight: 500;

      .noDataSubDiv {
        padding-top:10px;
        font-size: 16px;
        font-weight: 400;
        color: #515151;
      }
    }
  }
}


</style>


// WEBPACK FOOTER //
// Trend.vue?6b1d8b60